import * as React from 'react';
import { translate } from 'PyzShopUi/scripts/utils/translate';
import { IStoreConfig } from '../../../../../shop-ui/components/search-page/interfaces';
import { IProductItem } from '../../../../../shop-ui/interfaces';
import ProductItemsByCategory from './ProductItemsByCategory';
import Utils from 'PyzShopUi/scripts/utils/utils';

interface IProductResultListProps {
    products: IProductItem[];
    storeConfig: IStoreConfig;
}

const ProductResultList: React.FunctionComponent<IProductResultListProps> = props => {
    const { products, storeConfig } = props;

    const displayProductItemsByCategory = () => {
        const productGroupByCategory = products.reduce((category, product) => {
            category[product.categoryName] = [...category[product.categoryName] || [], product];
            return category;
        }, {});

        const sortProductCategory = (a,  b): number => Utils.generateStringSlug(a) < Utils.generateStringSlug(b) ? -1 : 1;

        return Object.keys(productGroupByCategory)
            .sort(sortProductCategory)
            .map(category => (
            <ProductItemsByCategory
                key={category}
                title={category}
                products={productGroupByCategory[category]}
                storeConfig={storeConfig}
            />
        ));
    };

    return (
        <div className='product-result-list'>
            <table>
                <thead>
                    <tr>
                        <th>
                            <span className='header'> {translate('Article variants', 'article-list')} </span>
                        </th>
                        <th>
                            <span className='header'> {translate('Art. No.', 'article-detail')} </span>
                        </th>
                        <th>
                            <span className='header'> {translate('Price', 'article-list')} </span>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {displayProductItemsByCategory()}
                </tbody>
            </table>
        </div>
    );
};

export default ProductResultList;
